import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
var styles=require('./Report.less');
import * as reportActions from './../../actions/reportActions';
import moment from 'moment';
import AccountDashboard from '../Report/AccountDashboard';
import StatementOfAccount from '../Report/StatementOfAccount';
import AlldealReport from '../Report/AlldealReport';
import ActivityLogRegister from '../Report/ActivityLogRegister';
import TradeAnalysisReport from '../Report/TradeAnalysisReport';
import OnlineOrderReport from '../Report/OnlineOrderReport';
import FixingOrdersReport from '../Report/FixingOrdersReport';
import OrderHistoryReport from '../Report/OrderHistoryReport';
import TradeRegister from '../Report/TradeRegister';
import '../../theme/styles/react-web-tabs.css';
import * as instrumentListActions from './../../actions/instrumentListActions';
import * as dashboardActions from './../../actions/dashboardActions';
import * as commonActions from './../../actions/commonActions';
import config from './../../config.js';
import {Tabs, Tab, TabPanel, TabList} from 'react-web-tabs';
import renderHTML from 'react-render-html';
import i18next from 'i18next';
import { setDirection,applyStyle, applyClickActive, applyToHover } from './../../utils/utils';
import MUIIconWithTooltip from '../../components/IconMaterialUI/MUIIconWithTooltip';

const elementsData = [
  {"classNames":"reportheader", "elementType":"normal", "applyTo":"single", "tagNames":"div","parent":"reportsBg"},
  {"classNames":"tabName", "elementType":"tabs", "applyTo":"all", "tagNames":"button", "parent":"reportheader"},
  {"classNames":"reportsBg", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"active","elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"tabsList ","elementType":"normal", "applyTo":"all", "tagNames":"div","parent":"sidebar"},
  {"classNames":"rptheader", "elementType":"normal", "applyTo":"single", "tagNames":"label","parent":"reportheader"},
];

const directionData=[
  {"classNames":"rptHeader","elementType":"normal", "applyTo":"single", "tagNames":"label"},
  {"classNames":"tabsList","elementType":"normal", "applyTo":"single", "tagNames":"div","parent":"sidebar"},
]

const refreshIcon = <MUIIconWithTooltip icon={'Refresh'} className={`${styles.clsIcon}`} title={i18next.t("refresh")}/>
const closeIcon = <MUIIconWithTooltip icon={'Close'} className={`closeBtn commonCloseIcon`} title={i18next.t("close")}/>

@connect(state => ({
  userDetail:state.auth.userDetail,
  DFA: state.auth.DFA,
  ACD: state.auth.ACD,
  selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
  checkClickOnAddWidgetFlag:state.dashboardRoot.commonReducer.checkClickOnAddWidgetFlag,
  checkLockFlag:state.dashboardRoot.commonReducer.checkLockFlag,
  socketDataStatic:state.dashboardRoot.instrumentListReducer.socketDataStatic,
  selectedCssColor:state.dashboardRoot.commonReducer.selectedCssColor,
  selectedLang:state.dashboardRoot.commonReducer.selectedLang,
  language:state.dashboardRoot.commonReducer.language,
  socketData: state.dashboardRoot.instrumentListReducer.socketData,
  stockCodeList:state.dashboardRoot.dashboardReducer.stockCodeList,
  loadAllRate:state.dashboardRoot.instrumentListReducer.loadAllRate,
  socketAllRate:state.dashboardRoot.instrumentListReducer.socketAllRate,
  stkCodeWisePair:state.dashboardRoot.commonReducer.stkCodeWisePair,
  dropdown:state.dashboardRoot.instrumentListReducer.dropdown,
  instData:state.dashboardRoot.instrumentListReducer.instData,
  userDetail: state.auth.userDetail,
}), {
  ...reportActions,
  ...instrumentListActions,
  ...dashboardActions,
  ...commonActions
})

export default class ReportComponent extends Component {
  static propTypes = {
    loadstatementOfaccountReport: PropTypes.func.isRequired,
    DFA: PropTypes.object,
    ACD: PropTypes.object,
    checkLockFlag:PropTypes.bool,
    socketData: PropTypes.array,
    loadAllRate:PropTypes.bool,
    loadAllRateData:PropTypes.func,
    socketAllRate:PropTypes.array,
    stkCodeWisePair:PropTypes.array,
    dropdown: PropTypes.object,
    instData:PropTypes.array,
  }

  state = {
    startDate: moment().format('DD-MM-YYYY'),
    endDate: moment().format('DD-MM-YYYY'),
    isClearSOAreport:false,
    isClearAllDeal :false,
    isClearOnlineReg :false,
    isClearBenchReg :false,
    isClearOrdHistory :false,
    isClearActivityLog:false,
    isClearAccountDash:false,
    isClearTrdAnalysis:false,
	  isClearTradeReg:false,
    isClearFixingRpt:false,
    tabId:'tab1',
    selectedStkcode:''
  }

  componentDidMount() {
    this.setState({selectedStkcode:this.props.stockCodeList[0].unit_code})
    const thisComponent = ReactDOM.findDOMNode(this);
    ////const allCssStyleRules = this.props.selectedCssColorTheme;
    //applyStyle(thisComponent, allCssStyleRules, elementsData);
    //applyClickActive(thisComponent.getElementsByClassName("rwt__tab "), allCssStyleRules,"reportheader");
    setDirection(ReactDOM.findDOMNode(this),directionData,this.props.selectedLang);
    window.onloadAccDash = this.onloadAccDash.bind(this);
    window.onloadSOAreport = this.onloadSOAreport.bind(this);
    window.onloadAllDeal = this.onloadAllDeal.bind(this);
    window.onloadOnlineReg = this.onloadOnlineReg.bind(this);
    window.onloadBenchReg = this.onloadBenchReg.bind(this);
    window.onloadOrdHistory = this.onloadOrdHistory.bind(this);
    window.onloadActivityLog = this.onloadActivityLog.bind(this);
    window.onloadTrdAnalysis = this.onloadTrdAnalysis.bind(this);
    window.onloadTradeReg = this.onloadTradeReg.bind(this);
    window.onloadFixingOrder=this.onloadFixingOrder.bind(this);

    if((this.props.userDetail.newRiskCheckType==="MT_Perc" || this.props.userDetail.newRiskCheckType ==="MT_DMC" || (this.props.userDetail.newRiskCheckType ==="MT_AsPerAcc" && this.props.DFA.MT==="MT_Perc") || (this.props.userDetail.newRiskCheckType ==="MT_AsPerAcc" && this.props.DFA.MT==="MT_DMC")) && this.props.userDetail.SUB_TRD!=true){
      this.setState({tabId:"tab1"})
      this.onloadAccDash();
    } else if(this.props.userDetail.newRiskCheckType ==="MT_NoMrg" || (this.props.userDetail.newRiskCheckType ==="MT_AsPerAcc" && this.props.DFA.MT==="MT_NoMrg") && this.props.userDetail.SUB_TRD!=true) {
      this.onloadSOAreport();
      this.setState({tabId:"tab2"});
    } else{
      this.onloadTradeReg();
      this.setState({tabId:"tab8"});
    }

   var testbody = document.querySelector("body");
   testbody.setAttribute("class", this.props.selectedCssColor);
   this.props.loadAllRateData(true);
  }

  componentWillMount() {
    const locale = locale;
    this.setState({
        locale: {
            'format': 'DD-MM-YYYY'
        },
    });
  }

  componentDidUpdate(preProps){
     const thisComponent = ReactDOM.findDOMNode(this);
    //  //const allCssStyleRules = this.props.selectedCssColorTheme;
    //  applyStyle(thisComponent, allCssStyleRules, elementsData);
    //  applyClickActive(thisComponent.getElementsByClassName("tabName"), allCssStyleRules,"reportheader");
     var testbody = document.querySelector("body");
     testbody.setAttribute("class", this.props.selectedCssColor);
  }

  componentWillReceiveProps(nextProps){
    // if(this.props.selectedCssColorTheme !== nextProps.selectedCssColorTheme){
    //   const thisComponent = ReactDOM.findDOMNode(this);
    //   const allCssStyleRules = nextProps.selectedCssColorTheme;
    //   applyStyle(thisComponent, allCssStyleRules, elementsData);
    //   applyClickActive(thisComponent.getElementsByClassName("tabName"), allCssStyleRules,"reportheader");
    //   var testbody = document.querySelector("body");
    //   testbody.setAttribute("class", nextProps.selectedCssColor);
    // }
    if(nextProps.checkClickOnAddWidgetFlag !== false){
      const thisComponent = ReactDOM.findDOMNode(this);
      // const allCssStyleRules = nextProps.selectedCssColorTheme;
      // applyStyle(thisComponent, allCssStyleRules, elementsData);
      // applyClickActive(thisComponent.getElementsByClassName("tabName"), allCssStyleRules,"reportheader");
    }
    if (this.props.selectedLang !== nextProps.selectedLang) {
      const thisComponent = ReactDOM.findDOMNode(this);
      setDirection(ReactDOM.findDOMNode(this),directionData,nextProps.selectedLang);
    }
    if(this.props.DFA.MT !== nextProps.DFA.MT){
      if(nextProps.DFA.MT==="MT_NoMrg"){
        this.onloadSOAreport();
        this.setState({tabId:"tab2"});
      } else {
        this.setState({tabId:"tab1"});
        this.onloadAccDash();
      }
    }
  }

  onloadAccDash=()=>{
    try{
      //this.props.loadAllRateData(false);
      this.setState({isClearAccountDash: true});
      this.setState({isClearSOAreport: false});
      this.setState({isClearAllDeal: false});
      this.setState({isClearOnlineReg: false});
      this.setState({isClearBenchReg: false});
      this.setState({isClearOrdHistory: false});
      this.setState({isClearActivityLog: false});
      this.setState({isClearTradeReg: false});
      this.setState({isClearTrdAnalysis:false});
      this.setState({PositionAcc_opt: this.props.DFA.D});
      this.setState({PositionAcc_key: this.props.DFA.C});
      const user = JSON.parse(localStorage.getItem('user'));
      this.props.loadAccBalMargin(JSON.parse(localStorage.getItem("DFA")).C,user.UID,false);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onloadAccDash', component:"ReportComponent"});
    }
  }

  onloadSOAreport=()=>{
    try{
      //tab2()
      //this.props.loadAllRateData(false);
      this.setState({isClearSOAreport: true});
      this.setState({isClearAccountDash: false});
      this.setState({isClearAllDeal: false});
      this.setState({isClearOnlineReg: false});
      this.setState({isClearBenchReg: false});
      this.setState({isClearOrdHistory: false});
      this.setState({isClearActivityLog: false});
      this.setState({isClearTradeReg: false});
      this.setState({isClearTrdAnalysis:false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onloadSOAreport', component:"ReportComponent"});
    }
  }

  onloadAllDeal=()=>{
    try{
      //tab3()
      //this.props.loadAllRateData(false);
      this.setState({isClearAllDeal: true});
      this.setState({isClearAccountDash: false});
      this.setState({isClearSOAreport: false});
      this.setState({isClearOnlineReg: false});
      this.setState({isClearBenchReg: false});
      this.setState({isClearOrdHistory: false});
      this.setState({isClearActivityLog: false});
      this.setState({isClearTradeReg: false});
      this.setState({isClearTrdAnalysis:false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onloadAllDeal', component:"ReportComponent"});
    }
  }

  onloadOnlineReg=()=>{
    try{
      //this.props.loadAllRateData(false);
      this.setState({isClearOnlineReg: true});
      this.setState({isClearAccountDash: false});
      this.setState({isClearAllDeal: false});
      this.setState({isClearSOAreport: false});
      this.setState({isClearBenchReg: false});
      this.setState({isClearOrdHistory: false});
      this.setState({isClearActivityLog: false});
      this.setState({isClearTradeReg: false});
      this.setState({isClearTrdAnalysis:false});
      this.props.loadOnlineReport(this.state.startDate, this.state.endDate, '', 'O', '',this.props.DFA.C, '2','');
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onloadOnlineReg', component:"ReportComponent"});
    }
  }

  onloadBenchReg=()=>{
    try{
      //this.props.loadAllRateData(false);
      this.setState({isClearBenchReg: true});
      this.setState({isClearAccountDash: false});
      this.setState({isClearAllDeal: false});
      this.setState({isClearSOAreport: false});
      this.setState({isClearOnlineReg: false});
      this.setState({isClearOrdHistory: false});
      this.setState({isClearActivityLog: false});
      this.setState({isClearTradeReg: false});
      this.setState({isClearTrdAnalysis:false});
      this.props.loadBenchMarkReport(this.state.startDate, this.state.endDate, 'All', 'O', 'O', '2', this.props.DFA.C);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onloadBenchReg', component:"ReportComponent"});
    }
  }

  onloadOrdHistory=()=>{
    try{
      //this.props.loadAllRateData(false);
      this.setState({isClearOrdHistory: true});
      this.setState({isClearAccountDash: false});
      this.setState({isClearAllDeal: false});
      this.setState({isClearSOAreport: false});
      this.setState({isClearOnlineReg: false});
      this.setState({isClearBenchReg: false});
      this.setState({isClearActivityLog: false});
      this.setState({isClearTradeReg: false});
      this.setState({isClearTrdAnalysis:false});
      this.props.loadReport('D', this.state.startDate, this.state.endDate, 'None', 'None');
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onloadOrdHistory', component:"ReportComponent"});
    }
  }

  onloadActivityLog=()=>{
    try{
      //this.props.loadAllRateData(false);
      this.setState({isClearActivityLog: true});
      this.setState({isClearAccountDash: false});
      this.setState({isClearAllDeal: false});
      this.setState({isClearSOAreport: false});
      this.setState({isClearOnlineReg: false});
      this.setState({isClearBenchReg: false});
      this.setState({isClearOrdHistory: false});
      this.setState({isClearTradeReg: false});
      this.setState({isClearTrdAnalysis:false});
      this.props.loadActivityReport('1','', '', 'D');
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onloadActivityLog', component:"ReportComponent"});
    }
  }

  onloadTradeReg=()=>{
    try{
      //this.props.loadAllRateData(false);
      this.setState({isClearActivityLog: false});
      this.setState({isClearAccountDash: false});
      this.setState({isClearAllDeal: false});
      this.setState({isClearSOAreport: false});
      this.setState({isClearOnlineReg: false});
      this.setState({isClearBenchReg: false});
      this.setState({isClearOrdHistory: false});
      this.setState({isClearTradeReg: true});
      let selectedStkCode=this.props.stockCodeList[0].unit_code
      this.props.loadTradeRegReport(this.state.startDate,  this.state.endDate,'All', selectedStkCode, 'D', 'O');
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onloadTradeReg', component:"ReportComponent"});
    }
  }

  onloadTrdAnalysis=()=>{
    try{
      //this.props.loadAllRateData(true);
      this.setState({isClearTrdAnalysis: true});
      this.setState({isClearActivityLog: false});
      this.setState({isClearAccountDash: false});
      this.setState({isClearAllDeal: false});
      this.setState({isClearSOAreport: false});
      this.setState({isClearOnlineReg: false});
      this.setState({isClearBenchReg: false});
      this.setState({isClearOrdHistory: false});

      let tempCol1=[...this.props.dropdown];
      var rateInput=0;
      let stkPair;
      stkPair = this.props.stkCodeWisePair.get(tempCol1[0].cmdtId).pair;
      rateInput=Math.abs(this.props.socketAllRate.get(stkPair).bid);
      this.props.getTradeanalysisReport(this.props.DFA.C, tempCol1[0].cmdtId, this.state.startDate, this.state.endDate, this.state.selectedStkcode, rateInput, '0', 'EN', '0');
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onloadTrdAnalysis', component:"ReportComponent"});
    }
  }

  activitySession_opt = (event) => {
    try{
      this.setState({activitySession_opt: event.target.text});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'activitySession_opt', component:"ReportComponent"});
    }
  }

  activity_order_opt = (event) => {
    try{
      this.setState({activity_order_opt: event.target.text});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'activity_order_opt', component:"ReportComponent"});
    }
  }

  changeTabs =(id) =>{
    try{
      this.setState({tabId:id});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'changeTabs', component:"ReportComponent"});
    }
  }

  onloadFixingOrder=()=>{
    try{
      this.setState({isClearFixingRpt: true});
      this.setState({isClearBenchReg: false});
      this.setState({isClearAccountDash: false});
      this.setState({isClearAllDeal: false});
      this.setState({isClearSOAreport: false});
      this.setState({isClearOnlineReg: false});
      this.setState({isClearOrdHistory: false});
      this.setState({isClearActivityLog: false});
      this.setState({isClearTradeReg: false});
      this.setState({isClearTrdAnalysis:false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onloadFixingOrder', component:"ReportComponent"});
    }
  }

  render() {
    const zeroQuantity = 0;
    const { activitySession_opt,  activity_order_opt,  type,  filterType, filterValue, startDate, endDate,exportSelection,  accCode,  cmdtyKey  } = this.state;
    const { exportFormat,  ordDateOpt, ordfilter_opt, cmdty_opt, actiontype_opt, ac_CodeOpt, docno_opt} = this.state;
    const {PositionAcc_opt} = this.state;
    const start = this.state.startDate;
    const end = this.state.endDate;
    let label = start + ' - ' + end;
    if (start === end) {
      label = start;
    }

    const isPosKeepingVisible = this.props.userDetail.newRiskCheckType==="MT_Perc" || (this.props.userDetail.newRiskCheckType==="MT_AsPerAcc" && this.props.DFA.MT==="MT_Perc") || this.props.userDetail.newRiskCheckType==="MT_DMC" || (this.props.userDetail.newRiskCheckType==="MT_AsPerAcc" && this.props.DFA.MT==="MT_DMC") 
    return (
      <div id="rptMainDiv" className={this.props.checkLockFlag === true ? `${styles.setLockClass} ${styles.container} reportsBg ${this.props.language}` : `${this.props.language} ${styles.setUnlockClass} ${styles.container} reportsBg`} >
    		<div className={`${styles.reporthead} reportheader`} >
    			<label className="rptHeader" >{i18next.t('reports')}</label>
    		</div>

    		<div className={styles.maincontentpanel}>
    			<Tabs defaultTab={this.state.tabId} onChange={(tabId) => this.changeTabs(tabId)} id="rptTabs">
    				<div className="sidebar">
    					{this.props.userDetail.SUB_TRD === false ?
                <TabList className="tabsList">
                  {isPosKeepingVisible ? <Tab tabFor="tab1" onClick={this.onloadAccDash} id="rptTab1" className="tabName active">{i18next.t('posKeeping')}</Tab>:null} {/* Renamed from Position Keeping to Account Dashboard */}
                  <Tab tabFor="tab2" onClick={this.onloadSOAreport} id="rptTab2" className="tabName">{i18next.t('statement')}</Tab>
                  <Tab tabFor="tab3" onClick={this.onloadAllDeal} id="rptTab3" className="tabName">{i18next.t('dealsRegister')}</Tab>
                  {this.props.userDetail.enableCustomerOrder ? <Tab tabFor="tab4" onClick={this.onloadOnlineReg} id="rptTab4" className="tabName" name='orderBookReport'>{i18next.t('orderBook')}</Tab>:null}
                  {this.props.userDetail.enableFXOrd ? <Tab tabFor="tab5" onClick={this.onloadFixingOrder} id="rptTab5" className="tabName">{i18next.t('fixingOrders')}</Tab>:null}
                  {this.props.userDetail.enableCustomerOrder ? <Tab tabFor="tab6" onClick={this.onloadOrdHistory} id="rptTab6" className="tabName" name='orderHistoryReport'>{i18next.t('ordHistory')}</Tab>:null}
                  <Tab tabFor="tab7" onClick={this.onloadActivityLog} id="rptTab7" className="tabName" name='activityLogReport'>{i18next.t('activityLog')}</Tab>
                  <Tab tabFor="tab9" onClick={this.onloadTrdAnalysis} id="rptTab8" className="tabName">{i18next.t('trdAnalysis')}</Tab>
                </TabList>
              :
                <TabList className="tabsList" >
                  <Tab tabFor="tab8" onClick={this.onloadTradeReg} id="rptTab8" className="tabName">{i18next.t('trdRegister')}</Tab>
                  <Tab tabFor="tab7" onClick={this.onloadActivityLog} id="rptTab7" className="tabName">{i18next.t('activityLog')}</Tab>
                </TabList>
              }
    				</div>

            <div>
              {this.state.tabId === "tab1" ?
                <TabPanel tabId="tab1">
                  <AccountDashboard isClearAccountDash={this.state.isClearAccountDash} refreshIcon={refreshIcon}/>
                </TabPanel>

              : this.state.tabId === "tab2" ?
                <TabPanel tabId="tab2">
                  <StatementOfAccount isClearSOAreport={this.state.isClearSOAreport} refreshIcon={refreshIcon} closeIcon={closeIcon}/>
                </TabPanel>

              : this.state.tabId === "tab3" ?
                <TabPanel tabId="tab3">
                  <AlldealReport isClearAllDeal={this.state.isClearAllDeal} refreshIcon={refreshIcon} closeIcon={closeIcon}/>
                </TabPanel>

              : this.state.tabId === "tab4" ?
                <TabPanel tabId="tab4">
                  <OnlineOrderReport isClearOnlineReg={this.state.isClearOnlineReg} refreshIcon={refreshIcon} closeIcon={closeIcon}/>
                </TabPanel>

              : this.state.tabId === "tab5" ?
                <TabPanel tabId="tab5">
                  <FixingOrdersReport isClearFixingRpt={this.state.isClearFixingRpt} refreshIcon={refreshIcon} closeIcon={closeIcon}/>
                </TabPanel>

              : this.state.tabId === "tab6" ?
                <TabPanel tabId="tab6">
                  <OrderHistoryReport isClearOrdHistory={this.state.isClearOrdHistory} refreshIcon={refreshIcon} closeIcon={closeIcon}/>
                </TabPanel>

              : this.state.tabId === "tab8" ?
                    <TabPanel tabId="tab8">
                  <TradeRegister isClearTradeReg={this.state.isClearTradeReg} refreshIcon={refreshIcon} closeIcon={closeIcon}/>
                </TabPanel>
              : this.state.tabId === "tab7"?
                <TabPanel tabId="tab7">
                  <ActivityLogRegister isClearActivityLog={this.state.isClearActivityLog} refreshIcon={refreshIcon} closeIcon={closeIcon}/>
                </TabPanel>
              :
                <TabPanel tabId="tab9">
                  <TradeAnalysisReport isClearTrdAnalysis={this.state.isClearTrdAnalysis} refreshIcon={refreshIcon} closeIcon={closeIcon}/>
                </TabPanel>
              }
            </div>
          </Tabs>
    		</div>
      </div>
    );
  }
}
